exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{box-sizing:border-box}body,html{font-family:Open Sans,sans-serif;background:#254356;overflow-x:hidden}.tabs{width:100%;padding:10px;text-align:center;border-bottom:1px solid #445d6e}.tabs-wrapper{text-align:center;margin-left:auto}.tabs button{height:10px;background:none;outline:0;border:none}.tabs button>svg{fill:#e0e4e7}.tabs button.hidden{display:inline}.tabs button.hidden>svg{fill:#445d6e}.labelarea{font-size:45%}.noderole{font-size:90%;font-weight:700}.nodemem{font-size:75%}.nodeplatform{font-size:80%}.nodelabel{font-style:italic}#app{margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/main.less
// module id = 24
// module chunks = 0